import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { Spinner } from '@cian/ui-kit';
import * as React from 'react';
import classNames from 'classnames';
import * as styles from './Button.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Button = function Button(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    onClick: props.onClick,
    disabled: props.disabled,
    className: classNames(styles['btn'], props.loading && styles['btn-loading']),
    children: [props.loading && /*#__PURE__*/_jsx("div", {
      className: styles['spinner'],
      "data-testid": "spinner",
      children: /*#__PURE__*/_jsx(Spinner, {
        size: 16
      })
    }), /*#__PURE__*/_jsx("span", {
      className: classNames(styles['content'], _defineProperty({}, styles['content-loading'], props.loading)),
      children: children
    })]
  });
};